import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
export const CrewProgressContainerStyled = styled(Box).attrs({
  flexGrow: { sm: '1' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: ${theme.spacings[400]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    overflow-y: hidden;
  `}
`;

export const ColumnContainerStyled = styled.div`
  ${({ theme }) => css`
    display: grid;
    padding-left: ${theme.spacings[450]};
    padding-right: ${theme.spacings[450]};
    padding-top: ${theme.spacings[300]};
    padding-bottom: ${theme.spacings[300]};
    grid-template-columns: 200px 1fr 1fr 1fr;
    justify-items: center;
    align-items: center;
  `}
`;

export const SeperatorStyled = styled(Box).attrs({
  mx: { sm: '200' },
})`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.grey[300]};
`;

export const CrewListContainerStyled = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  ul {
    margin-left: ${({ theme }) => theme.spacings['600']};
    li {
      &:last-child:before {
        position: absolute;
        top: 0;
        left: -14px;
        height: 40px; /* vertical position of line */
        vertical-align: top;
        content: '';
        display: inline-block;
        color: ${({ theme }) => theme.colors.grey['300']};
        border-left: 1px solid ${({ theme }) => theme.colors.grey['300']};
        z-index: 1; /* Needed to show the tree lines & crew bullets on the top of placeholder container used for item selection */
      }

      &:not(:last-child):before {
        position: absolute;
        top: 0;
        left: -14px;
        height: 100%; /* vertical position of line */
        vertical-align: top;
        content: '';
        display: inline-block;
        color: ${({ theme }) => theme.colors.grey['300']};
        border-left: 1px solid ${({ theme }) => theme.colors.grey['300']};
        z-index: 1; /* Needed to show the tree lines & crew bullets on the top of placeholder container used for item selection */
      }
    }
  }
`;
export const CrewListItemStyled = styled.li`
  position: relative;
  margin-left: 0;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: ${({ theme }) => theme.spacings['450']};
  padding-top: ${({ theme }) => theme.spacings['450']};
`;

export const CrewBulletStyled = styled.div`
  position: absolute;
  height: 10px;
  width: 10px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.grey['300']};
  left: -18px;
  top: 30px;
  z-index: 1; /* Needed to show the tree lines & crew bullets on the top of placeholder container used for item selection */
`;
